module.exports = __webpack_public_path__ + "img/boleto.055245f6.png";